import React, { useState } from 'react';
import Header from 'core/layout/Header';
import MinimalFooter from 'features/feature_home/components/MinimalFooter';
import CompanyList from '../components/CompanyList';
import {
    Box,
    Container,
    TextField,
    InputAdornment,
    Button,
    CircularProgress
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SearchHero from 'core/components/SearchHero';
import { Search as SearchLucide, MapPin } from 'lucide-react';
import { useTranslation } from 'core/context/TranslationContext';


function CompaniesPage() {
    const [searchFilters, setSearchFilters] = useState({});
    const [nameInput, setNameInput] = useState('');
    const [locationInput, setLocationInput] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const { _t } = useTranslation();

    const handleSubmit = (e) => {
        e.preventDefault();
        const filters = {};
        if (nameInput.trim()) filters.search = nameInput.trim();
        if (locationInput.trim()) filters.location = locationInput.trim();
        setSearchFilters(filters);
    };

    return (
        <>
            <Header />
            <Box
                sx={{
                    minHeight: '100vh',
                    bgcolor: 'grey.50',
                    display: 'flex',
                    flexDirection: 'column',
                    pt: 0
                }}
            >
                {/* Search hero */}
                <SearchHero
                    compact
                    title={_t('Top employers')}
                    lead={_t('Explore companies that are hiring right now.')}
                    onSubmit={handleSubmit}
                    loading={isSearching}
                    submitLabel={_t('Search')}
                    fields={[
                        { key: 'name', placeholder: _t('Company name or keyword'), icon: SearchLucide, value: nameInput, onChange: setNameInput },
                        { key: 'loc', placeholder: _t('City or country'), icon: MapPin, value: locationInput, onChange: setLocationInput }
                    ]}
                />

                {/* Company grid */}
                <Container maxWidth="xl" sx={{ pt: 2, pb: 3, flex: 1 }}>
                    <CompanyList
                        searchFilters={searchFilters}
                        onLoadingChange={setIsSearching}
                    />
                </Container>
            </Box>
            <MinimalFooter />
        </>
    );
}

export default CompaniesPage;
